/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Fade } from 'react-awesome-reveal';

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const handleChange = (e) => setForm({
    ...form,
    [e.target.name]: e.target.value,
  });

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required.';
    if (!form.email.trim()) e.email = 'Email is required.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      e.email = 'Enter a valid email address.';
    }
    if (!form.message.trim()) e.message = 'Please enter a message.';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (!validate()) return;
    setSending(true);
    setTimeout(() => {
      setSent(true);
      setSending(false);
      setForm({
        name: '', company: '', email: '', phone: '', service: '', message: '',
      });
      setErrors({});
    }, 800);
  };

  // eslint-disable-next-line implicit-arrow-linebreak
  const inputClass = (hasError) => `mt-1.5 block w-full rounded-xl px-4 py-3.5 text-sm border transition-all duration-200 outline-none bg-white text-surface-900 placeholder-surface-300/80 ${hasError ? 'border-red-300 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-surface-200 focus:border-brand-green-400 focus:ring-4 focus:ring-brand-green-50'}`;

  return (
    <div className="relative">

      {/* ═══════════════════════════════════════
          SECTION 1 — Quick contact channels
      ════════════════════════════════════════ */}
      <section className="py-20 lg:py-28 bg-white relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          {/* Channel cards */}
          <Fade direction="up" triggerOnce cascade damping={0.1}>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">

              {/* Card: Email */}
              <a
                href="mailto:info@dns-computer.net"
                className="glass-card group p-6 text-center hover:border-brand-green-200"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-brand-green-50 flex items-center justify-center group-hover:bg-brand-green-100 transition-colors">
                  <svg className="w-6 h-6 text-brand-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <p className="text-sm font-semibold text-surface-400 uppercase tracking-wider mb-1">Email&nbsp;Us</p>
                <p className="text-surface-900 font-bold">info@dns-computer.net</p>
              </a>

              {/* Card: Phone */}
              <a
                href="tel:+201223704138"
                className="glass-card group p-6 text-center hover:border-brand-green-200"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-brand-green-50 flex items-center justify-center group-hover:bg-brand-green-100 transition-colors">
                  <svg className="w-6 h-6 text-brand-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <p className="text-sm font-semibold text-surface-400 uppercase tracking-wider mb-1">Call&nbsp;Us</p>
                <p className="text-surface-900 font-bold">+2 01223704138</p>
                <p className="text-surface-900 font-bold">+20 36923271</p>
              </a>

              {/* Card: Location */}
              <a
                href="https://www.google.com/maps/search/?api=1&query=885+Alkhazan+St,+District+5,+6+of+October,+Giza,+Egypt"
                target="_blank"
                rel="noopener noreferrer" 
                className="glass-card group p-6 text-center hover:border-brand-green-200"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-brand-green-50 flex items-center justify-center group-hover:bg-brand-green-100 transition-colors">
                  <svg className="w-6 h-6 text-brand-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <p className="text-sm font-semibold text-surface-400 uppercase tracking-wider mb-1">Headquarters</p>
                <p className="text-surface-900 font-bold">6 of October, Giza</p>
              </a>

              {/* Card: Hours */}
              <div className="glass-card group p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-brand-green-50 flex items-center justify-center group-hover:bg-brand-green-100 transition-colors">
                  <svg className="w-6 h-6 text-brand-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <p className="text-sm font-semibold text-surface-400 uppercase tracking-wider mb-1">Business&nbsp;Hours</p>
                <p className="text-surface-900 font-bold">Mon — Fri, 9–6</p>
              </div>

            </div>
          </Fade>

          {/* ═══════════════════════════════════════
              SECTION 2 — Form + sidebar
          ════════════════════════════════════════ */}
          <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-start">

            {/* ─── LEFT: Form (3/5 cols) ─── */}
            <Fade direction="up" triggerOnce className="lg:col-span-3">
              <div className="glass-card-static p-8 sm:p-10 rounded-2xl">

                <h2 className="text-2xl sm:text-3xl font-extrabold text-surface-900 tracking-tight mb-2">
                  Send us a message
                </h2>
                <p className="text-surface-300 mb-8">
                  Fill out the form below and we&apos;ll get back to you within one business day.
                </p>

                {/* ── Success banner ── */}
                {sent && (
                  <Fade triggerOnce>
                    <div className="mb-8 p-5 bg-brand-green-50 text-brand-green-700 rounded-xl border border-brand-green-200 flex items-start gap-3">
                      <svg className="w-6 h-6 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <div>
                        <p className="font-bold text-sm">Message sent successfully!</p>
                        <p className="text-sm mt-0.5 opacity-80">Our team will get back to you shortly.</p>
                      </div>
                    </div>
                  </Fade>
                )}

                <form onSubmit={handleSubmit} className="space-y-5" noValidate>

                  {/* Row 1: Name + Company */}
                  <div className="grid sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-semibold text-surface-500">
                        Full Name <span className="text-red-400">*</span>
                        <input
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          className={inputClass(errors.name)}
                          placeholder="John Doe"
                          autoComplete="name"
                        />
                      </label>
                      {errors.name && <p className="text-xs text-red-500 mt-1.5">{errors.name}</p>}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-surface-500">
                        Company
                        <input
                          name="company"
                          value={form.company}
                          onChange={handleChange}
                          className={inputClass(false)}
                          placeholder="Acme Inc."
                          autoComplete="organization"
                        />
                      </label>
                    </div>
                  </div>

                  {/* Row 2: Email + Phone */}
                  <div className="grid sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-semibold text-surface-500">
                        Work Email <span className="text-red-400">*</span>
                        <input
                          name="email"
                          type="email"
                          value={form.email}
                          onChange={handleChange}
                          className={inputClass(errors.email)}
                          placeholder="you@company.com"
                          autoComplete="email"
                        />
                      </label>
                      {errors.email && <p className="text-xs text-red-500 mt-1.5">{errors.email}</p>}
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-surface-500">
                        Phone
                        <input
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          className={inputClass(false)}
                          placeholder="+1 (555) 123-4567"
                          autoComplete="tel"
                        />
                      </label>
                    </div>
                  </div>

                  {/* Row 3: Service interest */}
                  <div>
                    <label className="block text-sm font-semibold text-surface-500">
                      What are you interested in?
                      <select
                        name="service"
                        value={form.service}
                        onChange={handleChange}
                        className={`${inputClass(false)} appearance-none cursor-pointer`}
                      >
                        <option value="">Select a service…</option>
                        <option value="managed-it">Managed IT Services</option>
                        <option value="cybersecurity">Cybersecurity</option>
                        <option value="cloud">Cloud Solutions</option>
                        <option value="disaster-recovery">Disaster Recovery</option>
                        <option value="it-consulting">IT Consulting</option>
                        <option value="network-security">Network Security</option>
                        <option value="vcio">vCIO Services</option>
                        <option value="other">Other / General Inquiry</option>
                      </select>
                    </label>
                  </div>

                  {/* Row 4: Message */}
                  <div>
                    <label className="block text-sm font-semibold text-surface-500">
                      Message <span className="text-red-400">*</span>
                      <textarea
                        name="message"
                        rows="4"
                        value={form.message}
                        onChange={handleChange}
                        className={`${inputClass(errors.message)} resize-none`}
                        placeholder="Tell us about your project, goals, or any questions you have…"
                      />
                    </label>
                    {errors.message && <p className="text-xs text-red-500 mt-1.5">{errors.message}</p>}
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    disabled={sending}
                    className="btn-premium w-full justify-center text-base py-4 disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {sending ? (
                      <>
                        <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        Sending…
                      </>
                    ) : (
                      <>
                        Send Message
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </>
                    )}
                  </button>

                  <p className="text-xs text-surface-300 text-center mt-3">
                    By submitting this form you agree to our
                    {' '}
                    <a href="/privacy-policy" className="text-brand-green-500 hover:underline">Privacy Policy</a>.
                  </p>

                </form>
              </div>
            </Fade>

            {/* ─── RIGHT: Sidebar (2/5 cols) ─── */}
            <div className="lg:col-span-2 space-y-6">

              {/* Why reach out */}
              <Fade direction="up" delay={100} triggerOnce>
                <div className="glass-card-static p-6 rounded-2xl">
                  <h3 className="text-lg font-bold text-surface-900 mb-4 flex items-center gap-2">
                    <svg className="w-5 h-5 text-brand-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Why businesses choose DNS Computer
                  </h3>
                  <ul className="space-y-3">
                    {[
                      '5-minute average response time',
                      '100% service guarantee',
                      'Dedicated Client Success Manager',
                      '160+ happy clients',
                      '24/7 emergency support',
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-3 text-sm text-surface-300">
                        <svg className="w-4 h-4 text-brand-green-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Fade>

              {/* Quick booking CTA */}
              <Fade direction="up" delay={200} triggerOnce>
                <div className="relative overflow-hidden rounded-2xl">
                  {/* Green gradient bg */}
                  <div className="absolute inset-0 bg-gradient-to-br from-brand-green-500 to-brand-green-700" />
                  <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 80% 20%, white 0%, transparent 60%)' }} />

                  <div className="relative p-6 text-white">
                    <h3 className="text-lg font-bold mb-2">
                      Prefer a live conversation?
                    </h3>
                    <p className="text-sm text-white/80 mb-5 leading-relaxed">
                      Schedule a free 30-minute IT consultation with one of our experts — no strings attached.
                    </p>
                    <a
                      href="/book-consultation"
                      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-brand-green-700 font-semibold text-sm hover:bg-white/90 transition-colors shadow-lg"
                    >
                      Book a Free Call
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </a>
                  </div>
                </div>
              </Fade>

              {/* Social proof mini-card */}
              <Fade direction="up" delay={300} triggerOnce>
                <div className="glass-card-static p-6 rounded-2xl">
                  <div className="flex items-center gap-3 mb-3">
                    {/* Star icons */}
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map((s) => (
                        <svg key={s} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-sm font-bold text-surface-900">5.0</span>
                  </div>
                  <p className="text-sm text-surface-300 italic leading-relaxed">
                    &ldquo;DNS Computer is so great. Thank you so much for a job well done.&rdquo;
                  </p>
                  <p className="text-xs text-surface-400 mt-2 font-semibold">
                    — Reiner John, CEO at Marley CO
                  </p>
                </div>
              </Fade>

            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════
          SECTION 3 — Map / location strip
      ════════════════════════════════════════ */}
      <section className="bg-surface-50 py-16 border-t border-surface-200/50">
        <div className="container mx-auto px-6">
          <Fade direction="up" triggerOnce>
            <div className="text-center max-w-2xl mx-auto">
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
                Our Office
              </span>
              <h2 className="text-3xl font-extrabold text-surface-900 tracking-tight mb-3">
                Visit Us
              </h2>
              <p className="text-surface-300 mb-8">
                6 of October, 885 Alkhazan St, District 5, Giza, Egypt.
              </p>
            </div>
          </Fade>

          <Fade direction="up" delay={150} triggerOnce>
            <div className="rounded-2xl overflow-hidden shadow-glass-lg border border-surface-200/50 max-w-5xl mx-auto">
              <iframe
                title="DNS Computer Office Location"
                src="https://maps.google.com/maps?q=885+Alkhazan+St,+District+5,+6+of+October,+Giza,+Egypt&t=&z=13&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Fade>
        </div>
      </section>

    </div>
  );
}
